import React from 'react';
import Landing2 from '../landing-2/Landing';
import { getConfiguration } from '../data/utils';
import Landing3 from '../landing-3/Landing3';
import Landing4 from '../landing-4/Landing4';

export default function PrematchLanding(props) {
    const conf = getConfiguration();
    const landingType = conf.pls;

    switch (landingType) {
        case 'LANDING_WIDGETS':
            return <Landing2 />;
        case 'LANDING_3':
            return <Landing3 />;
        case 'LANDING_4':
            return <Landing4 />
        default:
            return props.fallback;
    }
}
